// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__T5YSM","large":"styles_large__u93AM"};